import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const { MOBILE_BREAKPOINT } = require('@src/styles/config');

export const StyledReferralIntroSection = styled('div')`
  .intro-container {
    display: flex;
    align-items: center;
    gap: 16px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      gap: 8px;
    }
  }

  .intro-content {
    flex: 1;
    color: ${COLOR.white};
  }

  .intro-title-container {
    display: flex;
    flex-direction: column;
  }

  .intro-title {
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    max-width: 375px;
    background: linear-gradient(
      101deg,
      #2506f9 -15.17%,
      #f1414d 77.34%,
      #f48b71 96.99%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 20px;
      line-height: 28px;
      min-width: 235px;
    }
  }

  .intro-description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
    margin-top: 8px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 12px;
      line-height: 16px;
      margin-top: 4px;
    }
  }

  .intro-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 28px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 14px;
    }
  }

  .referral-img {
    max-width: 155px;
    height: auto;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      max-width: 78px;
    }
  }
`;
